import moment from 'moment';
import {
  ETowerOption,
  IConstructionData,
  IContractsManagerState,
  IDeliveryConditions
} from '../../../store/ducks/contracts-and-constructions/types';
import {
  IResponsibleOfConstruction,
  EWeekDays
} from '../../../store/ducks/fabrication-contracts/types';
import { isValidEmail, isValid24hour } from '../../../utils/validateInputs';

export const isAllFieldsValidInConstructionData = (
  contractsManagerState: IContractsManagerState,
  constructionData?: IConstructionData
): boolean => {
  if (!constructionData) {
    return false;
  }

  const { address } = constructionData;
  const { towerOption, towers } = address;

  return (
    !contractsManagerState.loading &&
    !contractsManagerState.error &&
    (towerOption === ETowerOption.UNIQUE || (!!towers && towers?.length > 0))
  );
};

export const isAllFieldsValidInDeliveryConditions = (
  deliveryConditions: IDeliveryConditions
): boolean => {
  return (
    deliveryConditions.allowedVehicleTypes.length > 0 &&
    deliveryConditions.allowedDaysAndTimeToReceive.filter(
      (dayAndTime) => dayAndTime.checked
    ).length > 0 &&
    deliveryConditions.allowedDaysAndTimeToReceive
      .filter((dayAndTime) => dayAndTime.checked)
      .every((dayAndTime) => {
        if (!dayAndTime.startTime || !dayAndTime.endTime) {
          return false;
        }
        return (
          isValid24hour(dayAndTime.startTime) &&
          isValid24hour(dayAndTime.endTime) &&
          moment(dayAndTime.endTime, 'HH:mm').isSameOrAfter(
            moment(dayAndTime.startTime, 'HH:mm')
          )
        );
      })
  );
};

export const isAllFieldsValidInResponsiblesOfConstruction = (
  responsiblesOfConstruction: IResponsibleOfConstruction[]
): boolean => {
  return (
    responsiblesOfConstruction.length > 0 &&
    responsiblesOfConstruction.every(
      (resposible) =>
        resposible.name !== '' &&
        resposible.email !== '' &&
        isValidEmail(resposible.email) &&
        resposible.phoneNumber !== '' &&
        resposible.jobTitle !== ''
    )
  );
};

export const endTimeIsGreaterThanStartTime = (
  startTime?: moment.Moment,
  endTime?: moment.Moment
) => {
  if (!startTime || !endTime) {
    return false;
  }

  return endTime.isBefore(startTime);
};

export const weekDayMap = new Map<EWeekDays, string>();
weekDayMap.set(EWeekDays.MONDAY, 'Segunda-feira');
weekDayMap.set(EWeekDays.TUESDAY, 'Terça-feira');
weekDayMap.set(EWeekDays.WEDNESDAY, 'Quarta-feira');
weekDayMap.set(EWeekDays.THURSDAY, 'Quinta-feira');
weekDayMap.set(EWeekDays.FRIDAY, 'Sexta-feira');
weekDayMap.set(EWeekDays.SATURDAY, 'Sábado');
weekDayMap.set(EWeekDays.SUNDAY, 'Domingo');
